import React, { useState } from 'react';
import styles from './toggleSwitch.module.css';

const CustomCourse = ({ fileType, onFileTypeChange }) => {


const handleFileTypeChange = (fileType) => {
    onFileTypeChange(fileType)
}

  return (
    <div className={styles.course_button_container}>
        <div className={fileType == "Employee"? styles.blue_moving_ug : styles.blue_moving_pg}></div>
        <p className={fileType == "Employee" ? styles.active_font_ug : styles.font_ug} onClick={()=>{handleFileTypeChange("Employee")}}>Employee</p>
        <p className={fileType == "Employee"? styles.font_pg : styles.active_font_pg} onClick={()=>{handleFileTypeChange("Festival")}}>Festival</p>
    </div>
  );
};

export default CustomCourse;
